import { render } from "./AiAssistantPage.vue?vue&type=template&id=c9412612&scoped=true"
import script from "./AiAssistantPage.vue?vue&type=script&lang=js"
export * from "./AiAssistantPage.vue?vue&type=script&lang=js"

import "./AiAssistantPage.vue?vue&type=style&index=0&id=c9412612&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9412612"]])

export default __exports__